import { GetterTree } from "vuex"
import { BookingResource, BookingsState } from "~/store/bookings/bookings.types"
import { RootState } from "~/store/store.types"
import { getResource } from "~/utils/store"

const getters: GetterTree<BookingsState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []) => {
      if (state.data[id]) {
        return getResource<BookingResource>(state, id, rootGetters, included)
      }
      return null
    }
  }, 

  resources (state, getters) {
    return Object.values(state.data).map(data =>
      getters.resourceById(data.id, ['room', 'hotel', 'venues']))
  },
}

export default getters
